import grid from 'utils/lsp-grid/grid';

function filterPacks(deps, model, packs) {
  const gameNumbers = packs.map((game) => game.gameNo);
  return grid.setFilters(deps, 'manageInventory.packs', model, {
    gameNumber: gameNumbers,
  });
}

export default {
  filterPacks,
};



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/logic/manage-inventory.js